import {
  ChangeDetectorRef,
  Directive, ElementRef, forwardRef, Host, OnInit, Renderer2
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BsDatepickerComponent } from './bs-datepicker.component';
import { formatDate } from '../bs-moment/format';
import { getLocale } from '../bs-moment/locale/locales.service';

const BS_DATEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line
  useExisting: forwardRef(() => BsDatepickerInputDirective),
  multi: true
};


export class BsDatepickerInputDirective
  implements ControlValueAccessor {
  private _onChange = Function.prototype;
  private _onTouched = Function.prototype;

  constructor(  private _picker: BsDatepickerComponent,
    private _renderer: Renderer2,

    private _elRef: ElementRef,
    private changeDetection: ChangeDetectorRef) {
    this._picker.bsValueChange.subscribe((v: Date) => this._setInputValue(v));
  }

  _setInputValue(v: Date): void {
    const initialDate = formatDate(
      v,
      this._picker._config.dateInputFormat,
      this._picker._config.locale
    ) || '';
    this._renderer.setProperty(this._elRef.nativeElement, 'value', initialDate);
    this._onChange(v);
    this.changeDetection.markForCheck();
  }

  onChange(event: any) {
    this.writeValue(event.target.value);
    this._onTouched();
  }

  writeValue(value: Date | string) {
    if (!value) {
      this._picker.bsValue = null;
    }
    const _locale = getLocale(this._picker._config.locale);
    if (!_locale) {
      throw new Error(
        `Locale "${this._picker._config
          .locale}" is not defined, please add it with "defineLocale(...)"`
      );
    }
    if (typeof value === 'string') {
      let dateParts = value.split("/");
      let now = new Date();
      let year = isNaN(parseInt(dateParts[2])) ? now.getFullYear() : parseInt(dateParts[2]);
      let month = isNaN(parseInt(dateParts[1])) ? now.getMonth() : parseInt(dateParts[1]) - 1;
      let day = isNaN(parseInt(dateParts[0])) ? now.getDate() : parseInt(dateParts[0]);
      const date = new Date(year, month, day);

      //const date = new Date(_locale.preparse(value));
      this._picker.bsValue = isNaN(date.valueOf()) ? null : date;
    }

    if (value instanceof Date) {
      this._picker.bsValue = value;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this._picker.isDisabled = isDisabled;
    if (isDisabled) {
      this._renderer.setAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
      return;
    }
    this._renderer.removeAttribute(this._elRef.nativeElement, 'disabled');
  }

  registerOnChange(fn: (value: any) => any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this._onTouched = fn;
  }

  onBlur() {
    this._onTouched();
  }

  hide() {
    this._picker.hide();
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `input[bsDatepicker]`,
  host: {
    '(change)': 'onChange($event)',
    '(keyup.esc)': 'hide()',
    '(blur)': 'onBlur()'
  },
  providers: [BS_DATEPICKER_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: BsDatepickerComponent, decorators: [{ type: Host }, ]},
{type: Renderer2, },
{type: ElementRef, },
{type: ChangeDetectorRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
